import Vue from 'vue';

const config = {
    hce: 'A person with annual compensation greater than $160,000 for the 2025 plan year ($155,000 for the 2024 plan year and $150,000 for the 2023 plan year) or',
    keyEmployee: 'An officer with annual compensation greater than $230,000 for the 2025 plan year ($220,000 for the 2024 plan year and $215,000 for the 2023 plan year) or'
}

const defaults = {
    step1: false,
    step2: false,
    step3: false,
    step3a: false,
    step4: false,
    step5: false,
    step6: false,
    totalCostOfBenefits: null,
    totalCostKeyEmployees: null,
    grossCompensationHces: null,
    grossCompensationNonHces: null,
    participatingHces: null,
    participatingNonHces: null,
    eligibleNonHces: null,
    totalNonHces: null,
    eligibleHces: null,
    totalHces: null
};

let answers = {
    ...defaults
}

function clearAnswers() {
    answers = { ...defaults };
}

const HelpBlock = Vue.component('help-block', {
    props: {
        label: { type: String },
        items: { type: Array }
    },
    template: `
        <div class="alert alert-info w-100">
            <div class="help-block mt-4 ml-2">
                <q-title :text="label" />
                <ul v-if="items && items.length">
                    <li v-for="(item, index) in items" :key="index">
                        <label>{{ item }}</label>
                    </li>
                </ul>
                <slot name="additional-info"></slot>
            </div>
        </div>`,
});

const Title = Vue.component('q-title', {
    props: { text: { type: String, required: true } },
    template: `<h5 style="font-size: 1.10em; font-weight: bold;">{{ text }}</h5>`
})

const Question = Vue.component('question', {
    components: { Title },
    props: {
        question: { type: String, required: true },
        value: { type: Boolean, required: true  }
     },
     data() {
        return { answer: this.value }
     },
     watch: { answer(a) { this.$emit('input', a); }},
     template: `
        <div class="form-group">
            <div class="row mb-3 ml-1">
                <q-title :text="question" />
                <slot name="definition"></slot>
            </div>
            <div class="row mb-3">
                <div class="form-check ml-3">
                    <input class="form-check-input" type="radio" name="pop-ndt-answer" id="pop-ndt-yes" :value="true" v-model="answer" />
                    <label class="form-check-label" for="pop-ndt-yes">Yes</label>
                </div>
                <div class="form-check ml-3">
                    <input class="form-check-input" type="radio" name="pop-ndt-answer" id="pop-ndt-no" :value="false" v-model="answer" />
                    <label class="form-check-label" for="pop-ndt-no">No</label>
                </div>
            </div>
            <div class="px-4 row full-width">
                <slot name="note"></slot>
            </div>
        </div>
     `
});

function parseNumeric(value) {
    return isNaN(value) ? null : parseFloat(value);
}

const categoriesMap = {
    'Eligibility Test' : ['step1', 'step2', 'step3', 'step3a', 'step3b', 'step4'],
    'Contributions &amp; Benefits Test' : ['step5', 'step5a', 'step6'],
    'Key Employee Concentration Test': ['step7']
}

const NdtStep = function(step, question, config) {
    var template = config.template ? config.template : '<question :question="question" v-model="answer" />';

    var component = {
        step,
        components: { Question, HelpBlock, Title },
        data() { return { question, answers, answer: false } },
        methods: {
            next() {
                return this.$emit('next', { ...this.$data, passed: this.passed, step: this.$options.step,
                    nextComponent: this.nextComponent, result: this.result, category: this.category })
            }
        },
        watch: {
            answer(newValue) {
                this.answers[this.$options.step] = newValue;
            }
        },
        computed: {
            category() {
                return _.findKey(categoriesMap, (steps) => steps.includes(this.$options.step));
            },
            passed() { return this.answer == true },
            result() { return [{ question: this.question, result: this.passed ? 'Pass' : 'Fail' }]; },
            details: () => [],
            nextEnabled: () => true,
            nextVisible: () => true,

            totalCostOfBenefits() { return parseNumeric(this.answers.totalCostOfBenefits); },
            totalCostKeyEmployees() { return parseNumeric(this.answers.totalCostKeyEmployees); },
            grossCompensationHces() { return parseNumeric(this.answers.grossCompensationHces); },
            grossCompensationNonHces() { return parseNumeric(this.answers.grossCompensationNonHces); },
            participatingHces() { return parseNumeric(this.answers.participatingHces); },
            participatingNonHces() { return parseNumeric(this.answers.participatingNonHces); },
            eligibleNonHces() { return parseNumeric(this.answers.eligibleNonHces); },
            totalNonHces() { return parseNumeric(this.answers.totalNonHces); },
            eligibleHces() { return parseNumeric(this.answers.eligibleHces); },
            totalHces() { return parseNumeric(this.answers.totalHces); },

            ...config
        },
        template: `
            <div class="alert alert-secondary">
                ${template}
                <div class="row mt-2 ml-1">
                    <input v-if="nextVisible" :disabled="!nextEnabled" type="button" class="btn btn-primary" value="Next" @click.prevent="next" />
                </div>
            </div>`
    }

    if(component.computed.template)
        delete component.computed.template;

    return component;
}

export { clearAnswers, config, NdtStep }



// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/helpers.js